import dayjs from 'dayjs'
import { some } from 'lodash'
import React from 'react'
import PdfExport from './PdfExport'
import { Header, LogListTable, NoteTable, PageNumbers } from './pdfContent'
import { tableStyles } from './styles'

interface HandoverPdfExportProps {
  handover: {
    createdOn: Date | null
    logsByResident: any[]
    notes: any[]
  }
  style: any
  title: string
}

export default class HandoverPdfExport extends React.Component<HandoverPdfExportProps> {
  getHandoverDoc = () => {
    const { createdOn, logsByResident, notes } = this.props.handover
    const hasLogs =
      logsByResident &&
      logsByResident.length &&
      some(logsByResident, (group) => !!group.logs.length)
    const hasNotes = notes && notes.length
    const date = createdOn || dayjs()

    const doc = {
      content: [],
      footer: PageNumbers,
      styles: tableStyles
    }

    if (hasLogs) {
      doc.content = [
        // @ts-ignore
        Header({ title: 'Handover logs', date }),
        // @ts-ignore
        ...logsByResident.map(ResidentLogsTable),
        // @ts-ignore
        ...doc.content
      ]
    }

    if (hasNotes) {
      doc.content = [
        // @ts-ignore
        ...doc.content,
        // @ts-ignore
        hasLogs ? { pageBreak: 'after', text: '' } : null,
        // @ts-ignore
        Header({ title: 'General notes', date }),
        // @ts-ignore
        NoteTable(notes)
      ]
    }

    return doc
  }

  getDocDefinition = () => {
    return new Promise((resolve, reject) => {
      if (!this.props.handover) {
        reject('Data not provided')
      } else {
        resolve(this.getHandoverDoc())
      }
    })
  }

  render() {
    const { style, title } = this.props
    return (
      <PdfExport
        getDocDefinition={this.getDocDefinition}
        pdfTitle={title}
        style={style}
      />
    )
  }
}

const ResidentLogsTable = (row: any) => {
  const { logs, resident } = row
  if (logs && !logs.length) return null
  return [
    {
      columns: [
        {
          margin: [0, 0, 0, 0],
          style: ['h2'],
          text: `${resident?.name?.first} ${resident?.name?.last}`
        },
        resident?.location?.room
          ? {
              alignment: 'right',
              margin: [0, 0, 0, 0],
              style: ['h2'],
              text: `Room: ${resident.location?.room}`
            }
          : null
      ]
    },
    // @ts-ignore
    LogListTable(row)
  ]
}
